import type { ExportResult } from "@opentelemetry/core";
import { ExportResultCode } from "@opentelemetry/core";
import type { ReadableSpan, SpanExporter } from "@opentelemetry/sdk-trace-web";
export type ShouldSampleSpan = (span: ReadableSpan) => boolean;
export class SpanFilteringExporter implements SpanExporter {
    constructor(private readonly innerExporter: SpanExporter, private readonly filters: ShouldSampleSpan[]) { }
    async shutdown(): Promise<void> {
        await this.innerExporter.shutdown();
    }
    async forceFlush(): Promise<void> {
        await this.innerExporter.forceFlush?.();
    }
    export(spans: ReadableSpan[], resultCallback: (result: ExportResult) => void) {
        const spansToSample = spans.filter((span) => this.filters.every((f) => f(span)));
        if (spansToSample.length === 0) {
            resultCallback({ code: ExportResultCode.SUCCESS });
        }
        else {
            this.innerExporter.export(spansToSample, resultCallback);
        }
    }
}
